
import { BlogPost } from "@/types/blog";
import { content } from "./content";

export const SocialMediaEmotionen: BlogPost = {
  title: "Social Media & Emotionen: Die unterschätzte Gefahr für deine Finanzentscheidungen",
  metaTitle: "Social Media & Finanzentscheidungen: Die Gefahr",
  excerpt: "Wie soziale Medien Emotionen manipulieren und Finanzentscheidungen beeinflussen. Schutzstrategien mit kritischem Denken und Selbstreflexion.",
  date: "02.04.2025",
  slug: "social-media-emotionen",
  imageUrl: "/images/blog/social-media-emotionen.jpg",
  author: 'Jörg Hörmann',
  authorTitle: 'Finanz- & Executive Coach',
  category: "Finanzpsychologie",
  tags: ["Social Media", "Emotionen", "Finanzentscheidungen", "Finanzpsychologie", "Selbstreflexion"],
  content
};

// This export matches what's expected in src/data/blog/index.ts
export const socialMediaEmotionenPost = SocialMediaEmotionen;
